import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Brain, CheckCircle, XCircle, Loader } from 'lucide-react';
import { BASE_URL } from '../config/api';

const AccountActivationPage = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const activateAccount = async () => {
      try {
        const token = localStorage.getItem('token');
        const tokenType = localStorage.getItem('tokenType');
        const headers = token && tokenType
          ? { Authorization: `${tokenType} ${token}` }
          : {};

        const response = await fetch(`${BASE_URL}/api/auth/activate/${uuid}`, {
          method: 'PUT',
          headers
        });

        if (response.ok) {
          setStatus('success');
        } else {
          const data = await response.json();
          setErrorMessage(data.message || 'Activation failed');
          setStatus('error');
        }
      } catch (error) {
        setErrorMessage('Network error. Please try again later.');
        setStatus('error');
      }
    };

    activateAccount();
  }, [uuid]);

  const renderContent = () => {
    switch (status) {
      case 'loading':
        return (
          <>
            <Loader className="h-16 w-16 text-yellow-400 mx-auto mb-6 animate-spin" />
            <h1 className="text-2xl font-bold mb-4">Se activează contul tău...</h1>
          </>
        );
      case 'success':
        return (
          <>
            <CheckCircle className="h-16 w-16 text-green-400 mx-auto mb-6" />
            <h1 className="text-2xl font-bold mb-4">Cont activat cu succes!</h1>
            <button
              onClick={() => navigate('/')}
              className="mt-6 bg-yellow-400 hover:bg-yellow-300 text-purple-900 font-bold py-2 px-6 rounded-lg transition"
            >
              Înapoi Acasă
            </button>
          </>
        );
      case 'error':
        return (
          <>
            <XCircle className="h-16 w-16 text-red-400 mx-auto mb-6" />
            <h1 className="text-2xl font-bold mb-4">Activare eșuată</h1>
            <p className="text-red-300 mb-6">{errorMessage}</p>
            <button
              onClick={() => navigate('/')}
              className="mt-6 bg-yellow-400 hover:bg-yellow-300 text-purple-900 font-bold py-2 px-6 rounded-lg transition"
            >
              Înapoi Acasă
            </button>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-indigo-500 text-white">
      <header className="container mx-auto py-6 px-4">
        <div 
          className="flex items-center space-x-2 cursor-pointer hover:opacity-80 transition-opacity"
          onClick={() => navigate('/')}
        >
          <Brain className="h-8 w-8" />
          <span className="text-2xl font-bold">PMind</span>
        </div>
      </header>

      <div className="container mx-auto px-4 py-20">
        <div className="max-w-md mx-auto">
          <div className="bg-white/10 backdrop-blur-lg rounded-xl p-8 text-center">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountActivationPage;
